module.exports = __webpack_public_path__ + "img/golden-ticket-display.8b3071b8.png";